<template>
<div>
<div id="main-card" class="card w-50 mx-auto p-5 d-flex align-items-center rounded shadow">
<!--QRP LOGO START-->
<div class="container h-100">
  <div class="row justify-content-md-center">
    <div class="col-12 mx-auto">
      <img :src="require(`./../assets/clients/${agencyLogo}.svg`)" id="qrp-logo" alt="Rating Platform Logo" width="150px" height="auto" v-if="agencyLogo" />
      <img id="qrp-logo" src="./../assets/qrp-rtm-color.svg" alt="QuinStreet Rating Platform" width="150px" height="auto" v-else />
    </div>
  </div>
</div>
<!--QRP LOGO END-->
<div id="card-inner-container" class="mx-auto w-100">

  <div class="row justify-content-md-center">
    <div class="col-12">
        <div class="row">
      <div class="col-12 col-lg-10 col-xl-7 mx-auto">
        <hr id="login-card-hr">
      </div>
    </div>

    <form class="my-3" autocomplete="off">

      <div class="row form-group">
      <div class="col-12 col-lg-10 col-xl-7 mx-auto">
        <field-label :fieldData="fieldElement['username']"></field-label>

        <field-tooltip :fieldData="fieldElement['username']"></field-tooltip>

        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text qrp-input-icon-background">
              <icon name="user" scale=".6" class="d-block mx-auto"></icon>
            </div>
          </div>

          <input type="text" class="form-control" :id="fieldElement['username'].field_name"
          :name="fieldElement['username'].field_name"
          v-model.trim="loginData.email"
          v-validate="''"
          v-bind:class="{'form-control': true,
            'error': errors.has(fieldElement['username'].field_name) }"
           ref="userNameRef">
        </div>

        <field-messages :fieldData="fieldElement['username']"></field-messages>
      </div>
      </div>

      <div class="row form-group">
        <div class="col-12 col-lg-10 col-xl-7 mx-auto">
          <field-label :fieldData="fieldElement['password']"></field-label>

          <field-tooltip :fieldData="fieldElement['password']"></field-tooltip>

          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text qrp-input-icon-background">
                <icon name="lock" scale=".6" class="d-block mx-auto"></icon>
              </div>
            </div>

            <input type="password"
            class="form-control"
            :id="fieldElement['password'].field_name"
            :name="fieldElement['password'].field_name"
            v-model="loginData.password"
            v-validate="''"
          v-bind:class="{'form-control': true,
            'error': errors.has(fieldElement['password'].field_name) }">
          </div>

          <field-messages :fieldData="fieldElement['password']"></field-messages>

          <div class="row mt-1">
            <div class="col text-right">
              <router-link :to="{ name: 'resetPassword', params: { viewUsage: 'reset' }}"
                class="small qrp-text-muted">Forgot Password?</router-link>
            </div>
          </div>

        </div>
      </div>
      <div class="text-center error-red text-notice mb-3" v-show="loginError">
            {{errorMsg}}
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-primary" @click.prevent="submitted">Sign In</button>
      </div>
    </form>
    <div class="row">
      <div class="col-12 col-lg-10 col-xl-7 mx-auto">
        <hr id="login-card-hr-bottom">
      </div>
    </div>

    </div>
  </div>

  <main-footer id="main-footer" role="contentinfo"></main-footer>

</div>
</div>
</div>
</template>
<script>
import Footer from './shared/Footer';
import FieldLabel from './presentational/FieldLabel';
import FieldTooltip from './presentational/FieldTooltip';
import FieldMessages from './presentational/FieldMessages';
import FormMessages from './presentational/FormMessages';
import User from '../services/User';
import common from '../services/common';
/* eslint-disable */
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      agencyLogo: '',
      fieldElement: {
        username: {
          label: 'Username',
          field_type: 'text_long',
          field_prepend: 'user',
          field_name: 'username',
          is_required: true,
          help_text: '',
        },
        password: {
          label: 'Password',
          field_type: 'text_long',
          field_prepend: 'lock',
          field_name: 'password',
          is_required: true,
          help_text: '',
        },
      },
      loginData: {
        email: '',
        password: '',
      },
      loginError: false,
      errorMsg: '',
      userNameRef:''
    };
  },
  components: {
    mainFooter: Footer,
    FieldLabel,
    FieldMessages,
    FieldTooltip,
    FormMessages,
    User,
  },
  methods: {
    submitted() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
           this.$refs.userNameRef.focus();
           return;
        }
        const startTimeVal = (new Date()).getTime();
        User.authenticateUser(
          this.loginData.email,
          this.loginData.password,
        ).then(() => {
          common.gapRecordAnalyticsGeneric(startTimeVal, 'API', 'Login');
          // check if callback url present
          const callBackUrl = this.$route.query.redirect;
         if (callBackUrl) {
            location.href = callBackUrl;
          }
         else {
            this.$router.push({ name: 'search' }); // Redirect user to search page after successful login
          }
        }).catch((error) => {
          this.errorMsg = error.response.data.error_description;
          this.loginError = true;
          this.$refs.userNameRef.focus();
          return Promise.reject(error);
        });
      }).catch((err) => {
        console.log('error', err);
      });
    }
  },
  created() {
    if (this.$store.getters.getAgencyLogo) {
      this.agencyLogo = this.$store.getters.getAgencyLogo;
    }
  },
  mounted() {
      this.userNameRef = this.fieldElement['username'].field_name;
    /* eslint no-undef: */
    /* eslint prefer-template:  */
    // gtag('config', '<%= process.env.GAID %>', { page_path: '/login' });
    // common.gapRecordAnalytics(initialTime, 'Login');
  },
 

};
</script>
<style scoped>
  #main-card {
    border-color: #F7F7F7;
    margin-top: 4rem;
  }

  #login-card-hr {
    margin: 0.625rem 0;
  }

  #login-card-hr-bottom {
    margin-bottom: .25rem;
  }

  #qrp-logo{
    display: block;
    width: 100%;
    max-width: 230px;
    height: inherit !important;
    margin:0 auto;
  }
 .input-group-prepend svg{
   fill: currentcolor;
  }

#main-footer {
  margin-bottom: 1rem;
  padding-top: .7rem;
  font-size: 0.75rem;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue?83664392